<template>
    <div>
        <v-alert border-color="primary" border="start" dense v-if="nb_inscrits_to_validate_webservice == 0">Il
            n'y a aucun coureur en attente de validation par webservice</v-alert>
        <div v-else>
            <v-alert border-color="primary" border="start" dense>
                Il y a <b>{{ nb_inscrits_to_validate_webservice }} coureur(s)</b> en attente de validation par le
                webservice.
            </v-alert>

            <div class="d-flex justify-center">
                <v-btn v-if="mainStore.authAdmin.isSportipsAdmin" class="my-2" color="primary-dark" variant="elevated"
                    elevation="0" @click="verify_webservice" :loading="loading">Lancer la
                    validation</v-btn>
            </div>


            <v-table>
                <thead>
                    <tr>
                        <th class="text-left">Nom - Prénom</th>
                        <th class="text-left">Date de naissance</th>
                        <th class="text-left">Numéro de licence</th>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="inscription in pending_webservice.list_inscriptions" :key="inscription.id">
                        <td>{{ inscription.nom }} {{ inscription.prenom }}</td>
                        <td>{{ $moment(inscription.date_naissance).format("DD/MM/YYYY") }}</td>
                        <td>
                            {{ inscription.champs.licence }}
                        </td>

                    </tr>
                </tbody>
            </v-table>
            <v-dialog v-model="show_validate" width="500" max-width="100%" scroll-strategy="none">
                <v-card>
                    <v-card-text>
                        <div class="text-body-1">Voulez-vous vraiment <b>valider</b> le document de ce participant ?
                        </div>
                        <div>Il recevra un email l'informant que son inscription est désormais validée et complète.
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="red-darken-4" @click="show_validate = false">Non</v-btn>
                        <v-btn color="green-darken-4" @click="handle_validate">Oui</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="show_reject" width="500" max-width="100%" scroll-strategy="none">
                <v-card>
                    <v-card-text>
                        <div class="text-body-1">Voulez-vous vraiment <b>rejeter</b> ce participant ?</div>
                        <div>Il recevra un email l'informant que son document est refusé et sera inviter à se rendre
                            sur sa fiche coureur pour en charger un nouveau.</div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="red-darken-4" @click="show_reject = false">Non</v-btn>
                        <v-btn color="green-darken-4" @click="handle_reject">Oui</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <v-snackbar v-model="snackbar_success" timeout="6000">
            <div>Les coureurs ont bien été validés par le webservice. Les coureurs restants ont un numéro de licence non
                valide (expiration/type de licence...)</div>

            <template v-slot:actions>
                <v-btn color="green-darken-1" variant="elevated" @click="snackbar_success = false"> Fermer </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>

import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service.js";
export default {
    name: 'ValidationLicences',
    data() {
        return {
            pending_webservice: {},
            loading: false,
            snackbar_success: false,
            // Your component data goes here
        };
    },
    methods: {
        async verify_webservice() {
            this.loading = true;
            let request = await AdminService.validateWebservice(this.mainStore.module.id);
            this.loading = false;
            if (!request.error) {
                this.fetch_list_pendings();
                this.snackbar_success = true;
            }
        },
        async fetch_list_pendings() {
            let request = await AdminService.getValidationWebservicePendings(this.mainStore.module.id);
            if (!request.error) {
                this.pending_webservice = request;
            }
        }
        // Your component methods go here
    },
    computed: {
        ...mapStores(useMainStore),
        nb_inscrits_to_validate_webservice() {
            if (!this.pending_webservice || !this.pending_webservice.list_inscriptions) return 0;
            return this.pending_webservice.list_inscriptions.length;
        },
        // Your computed properties go here
    },
    async mounted() {
        await this.fetch_list_pendings();
        // Your mounted lifecycle hook goes here
    }
};
</script>

<style scoped>
/* Your component styles go here */
</style>